import { z } from 'zod';

/** A user's two PCMP edit grants (false and false when they have none). */
export const pcmpEditGrantSchema = z.object({
  userId: z.coerce.number(),
  editAnyStage: z.boolean(),
  proposalCorrection: z.boolean(),
});

export type PcmpEditGrant = z.infer<typeof pcmpEditGrantSchema>;

const personSchema = z.object({
  userId: z.coerce.number(),
  fullName: z.string(),
});

/** One line of the grant list: a grant joined to the people it names. */
export const pcmpEditPermissionItemSchema = pcmpEditGrantSchema.extend({
  fullName: z.string(),
  hrEmpId: z.string().nullish(),
  /** At least one option on; a withdrawn row stays for the audit. */
  isGranted: z.boolean(),
  grantedBy: personSchema.nullish(),
  grantedAt: z.string(),
  updatedBy: personSchema.nullish(),
  updatedAt: z.string(),
});

export type PcmpEditPermissionItem = z.infer<typeof pcmpEditPermissionItemSchema>;

export const pcmpEditPermissionItemsSchema = z.array(pcmpEditPermissionItemSchema);

/** An active General User the grant form's picker finds. */
export const pcmpGrantableUserSchema = z.object({
  userId: z.coerce.number(),
  fullName: z.string(),
  username: z.string().nullish(),
  hrEmpId: z.string().nullish(),
  designationName: z.string().nullish(),
  departmentName: z.string().nullish(),
});

export type PcmpGrantableUser = z.infer<typeof pcmpGrantableUserSchema>;

export const pcmpGrantableUsersSchema = z.array(pcmpGrantableUserSchema);
